import api from './api';

export const cotizacionesService = {
  /**
   * Obtener todas las cotizaciones
   * @param {number} sucursalId - ID de la sucursal para filtrar (opcional)
   * @param {number} clienteId - ID del cliente para filtrar (opcional)
   * @param {string} fechaDesde - Fecha desde (opcional)
   * @param {string} fechaHasta - Fecha hasta (opcional)
   * @param {string} estatus - Estatus de la cotización (opcional)
   */
  getAll: async (sucursalId = null, clienteId = null, fechaDesde = null, fechaHasta = null, estatus = null) => {
    const params = {};
    if (sucursalId) params.sucursalId = sucursalId;
    if (clienteId) params.clienteId = clienteId;
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    if (estatus) params.estatus = estatus;
    const response = await api.get('/cotizaciones', { params });
    return response;
  },

  /**
   * Obtener una cotización por ID
   * @param {number} id - ID de la cotización
   */
  getById: async (id) => {
    const response = await api.get(`/cotizaciones/${id}`);
    return response;
  },

  /**
   * Obtener una cotización por folio
   * @param {string} folio - Folio de la cotización
   */
  getByFolio: async (folio) => {
    const response = await api.get(`/cotizaciones/folio/${folio}`);
    return response;
  },

  /**
   * Crear una nueva cotización
   * @param {object} cotizacion - Datos de la cotización
   */
  create: async (cotizacion) => {
    const response = await api.post('/cotizaciones', cotizacion);
    return response;
  },

  /**
   * Convertir una cotización a venta
   * @param {number} id - ID de la cotización
   * @param {object} datos - Datos para la conversión (métodos de pago, folio de venta, observaciones)
   */
  convertirAVenta: async (id, datos) => {
    const response = await api.post(`/cotizaciones/${id}/convertir-a-venta`, datos);
    return response;
  },
};